module.exports = __webpack_public_path__ + "img/图1-31使用四心圆法画椭圆.4cecff4c.png";